import {
  primitiveColor
} from "./chunk-TUU3BKKT.mjs";

// src/tokens/colors/semanticColor.ts
var baseSemanticColor = {
  brand: {
    strong: primitiveColor.pink[80],
    default: primitiveColor.pink[70],
    subtle: primitiveColor.pink[50],
    subtler: primitiveColor.pink[20],
    subtlest: primitiveColor.pink[5]
  },
  status: {
    success: {
      default: primitiveColor.green[70],
      subtle: primitiveColor.green[50],
      subtler: primitiveColor.green[20],
      subtlest: primitiveColor.green[10]
    },
    warning: {
      default: primitiveColor.yellow[70],
      subtle: primitiveColor.yellow[50],
      subtler: primitiveColor.yellow[20],
      subtlest: primitiveColor.yellow[10]
    },
    error: {
      default: primitiveColor.red[70],
      subtle: primitiveColor.red[50],
      subtler: primitiveColor.red[20],
      subtlest: primitiveColor.red[10]
    },
    processing: {
      default: primitiveColor.blue[70],
      subtle: primitiveColor.blue[50],
      subtler: primitiveColor.blue[20],
      subtlest: primitiveColor.blue[10]
    }
  },
  text: {
    primary: primitiveColor.neutral[100],
    secondary: primitiveColor.neutral[80],
    tertiary: primitiveColor.neutral[60],
    quaternary: primitiveColor.neutral[50],
    inverse: primitiveColor.neutral[0]
  },
  icon: {
    primary: primitiveColor.neutral[100],
    secondary: primitiveColor.neutral[80],
    tertiary: primitiveColor.neutral[60],
    quaternary: primitiveColor.neutral[50],
    inverse: primitiveColor.neutral[0]
  },
  background: {
    default: primitiveColor.neutral[0],
    subtle: primitiveColor.neutral[5],
    modal: primitiveColor.neutral[0]
  },
  line: {
    clickable: primitiveColor.neutralBlueAlpha[15],
    nonClickable: primitiveColor.neutralBlueAlpha[12],
    selected: primitiveColor.neutral[80]
  },
  dimm: {
    default: primitiveColor.neutralBlackAlpha[60]
  },
  fill: {
    default: primitiveColor.neutral[0],
    subtle: primitiveColor.neutral[10],
    inverse: {
      default: primitiveColor.neutral[100],
      subtle: primitiveColor.neutral[80]
    }
  }
};

export {
  baseSemanticColor
};
